import React from "react";

/**
 * Reusable legal-consent checkbox: links to Privacy Notice and T&C.
 * Used by payment forms, registration, and any future contact/contract form.
 */
export default function LegalConsent({ checked, onChange, testId }) {
  return (
    <label
      htmlFor={testId}
      className={`flex items-start gap-3 mb-4 p-3 rounded-xl border-2 cursor-pointer transition-colors ${
        checked ? "bg-emerald-50 border-emerald-300" : "bg-zinc-50 border-zinc-200 hover:border-zinc-300"
      }`}
    >
      <input
        id={testId}
        data-testid={testId}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 w-5 h-5 accent-emerald-600 flex-shrink-0 cursor-pointer"
      />
      <span className="text-xs sm:text-sm text-zinc-800 leading-snug">
        He leído y acepto el{" "}
        <a
          href="/aviso-de-privacidad"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold text-blue-800 underline hover:text-blue-900"
          data-testid={`${testId}-aviso-link`}
        >
          Aviso de Privacidad
        </a>{" "}
        y los{" "}
        <a
          href="/terminos-y-condiciones"
          target="_blank"
          rel="noopener noreferrer"
          className="font-bold text-blue-800 underline hover:text-blue-900"
          data-testid={`${testId}-terminos-link`}
        >
          Términos y Condiciones
        </a>
        . Entiendo que miapoyo.com es un asistente automatizado de educación legal y NO sustituye a un abogado.
      </span>
    </label>
  );
}
